export const getEmail = state => state.forgotPassword.email;
